import type { Account } from '@shared/products-types';
import type { ProductWithHelpers } from '@shared/products-core';

export const getDefaultTitle = (account?: Account | ProductWithHelpers): string => {
    const { description, productI18N } = account as Account;
    const { defaultTitle, underlyingCard, underlyingData } = account as ProductWithHelpers;

    if (defaultTitle) {
        return defaultTitle;
    }

    return (
        productI18N ||
        underlyingCard?.productI18N ||
        (underlyingData as { productI18N?: string })?.productI18N ||
        description
    );
};

export const getTitleAlignedWithGeorgeApp = (
    account?: Account | ProductWithHelpers,
): string | undefined => {
    if (!account) {
        return undefined;
    }

    const { alias } = account as Account;
    const { underlyingCard } = account as ProductWithHelpers;

    if (alias && alias !== underlyingCard?.owner) {
        return alias;
    }

    return getDefaultTitle(account);
};

export const getStrictTitleAlignedWithGeorgeApp = (
    account?: Account | ProductWithHelpers,
): string => {
    if (!account) {
        return '';
    }

    return getTitleAlignedWithGeorgeApp(account) ?? '';
};
